import * as d3 from "d3";
import {
    colonAnnotation,
    createTooltip,
    DEFAULT_AXIS_LABEL_FONT_SIZE,
    inrFormatter,
    numberFormat, responsivefy
} from '../functions'

export default function (chart, divId, vizName, resData) {
    const defaultSize = true
    const defaultChartLayout = {
        width: 1000,
        height: 400,
        margin: { top: 10, right: 150, bottom: 100, left: 20 }
    }
    const chartWidth = defaultSize ? defaultChartLayout.width : chart.width
    const chartHeight = defaultSize ? defaultChartLayout.height : chart.height
    const chartMargin = defaultSize ? defaultChartLayout.margin : chart.margin
    //const fontSize = (defaultSize ? DEFAULT_AXIS_FONT_SIZE : chart.axisFontSize) + "px"
    const axisLabelFontSize = (defaultSize ? DEFAULT_AXIS_LABEL_FONT_SIZE : chart.axisLabelFontSize) + "px"

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    // load the data
    // axios.post(url, filterParam).then(res => {
        let data = resData;
        console.log("data is:", data)
        const itemGapX = 110
        const rowGapY = 280
        const startX = 40
        const topRowY = 120
        const bottomRowY = 210
        const perRow = Math.max(1, Math.floor((chartWidth - 40) / itemGapX))
        const rowIndex = (i) => Math.floor(i / perRow)
        const colIndex = (i) => i % perRow
        const pointX = (i) => startX + colIndex(i) * itemGapX
        const pointYTop = (i) => topRowY + rowIndex(i) * rowGapY
        const pointYBottom = (i) => bottomRowY + rowIndex(i) * rowGapY
        const extraRows = Math.max(0, Math.ceil(data.length / perRow) - 1)
        const dynamicHeight = chartHeight + chartMargin.top + chartMargin.bottom + extraRows * rowGapY

        // var width = 2700;
        // var height = 230;

        var categories = d3.nest()
            .key(function (d) {
                return d.dim1_name;
            })
            //  .key(function(d) { return d.dim2_name; }).sortKeys(d3.ascending)
            .entries(data);

        console.log("cat", categories)
        var color = d3.scaleOrdinal()
            .domain(categories[0].values.map(function (d) {
                return d.dim2_name;
            }).sort(d3.ascending))
            .range(["blue", "red", "orange"])


        console.log("datampainn", categories[0].values.map(function (d) {
            return d.dim2_name;
        }).sort(d3.ascending));

        var svg = d3.select(divId).select("svg").remove();

        // Make SVG container
        svg = d3
            .select(divId)
            .style("text-align", "left")
            //   .classed("svg-container", true)
            .append("svg")
            .attr('width', chartWidth + chartMargin.left + chartMargin.right)
            .attr('height', dynamicHeight)
            .call(responsivefy)
            .style("display", "block")
            .style("margin-left", "0")
            .style("margin-right", "auto")

        const rootG = svg.append("g")
            .attr("transform", `translate(${chartMargin.left},${chartMargin.top})`)

        var elem = rootG
            .selectAll("g.pie-ring")
            .data(data);

        var elemEnter = elem
            .enter()
            .append("g")
            .attr("class", "pie-ring")


        var circles = elemEnter
            .append("circle")
            .attr("cx", function (d, i) {
                return pointX(i)
            })
            .attr("cy", function (d, i) {
                return pointYTop(i)
            })
            // .attr("r",function(d) { return rscale(d.metric1)*20})
            .attr("r", 38)
            .style("fill", "white")
            .style("stroke-width", "6px")
            .style("stroke", function (d) {
                return color(d.dim2_name)
            });


        console.log(circles)
        elemEnter
            .append("text")
            .text(function (d) {
                return numberFormat(d.metric1)
            })
            .style('text-anchor', 'middle')
            .style("fill", "black")
            .attr("x", function (d, i) {
                return pointX(i)
            })
            .attr("y", function (d, i) {
                return pointYTop(i) + 5
            })
            .style("font-size", axisLabelFontSize)
            .style("font-weight", "bold")


        elemEnter
            .append("text")
            .style("fill", "black")
            .attr("x", function (d, i) {
                return pointX(i) - 10
            })
            .attr("y", function (d, i) {
                return pointYTop(i) - 45
            })
            // .attr("dy", 85)
            // .attr("dx",  function(d,i){ return 45 -120 *i
            // })
            .text(function (d) {
                return d.dim1_name
            })
            .style("text-anchor", "start")
            .style("font-weight", "bold")
            .style("font-size", axisLabelFontSize)
            .attr('transform', function (d, i) {
                return 'rotate(-60,' + (pointX(i) - 10) + ',' + (pointYTop(i) - 40) + ')'
            });

        var rscale = d3.scaleSqrt()
            .domain([d3.min(data, function (d) {
                return d.metric1
            }), d3.max(data, function (d) {
                return d.metric1
            })])
            .range([8, 36])

    const tooltip = createTooltip(divId);
        // d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        // var div = d3.select(divId).append('div').attr('class', 'tooltip')
        //     .attr('style', 'position: absolute; opacity: 0;')

        var elem2 = rootG
            .selectAll("g.pie-fill")
            .data(data);

        var elemEnter2 = elem2
            .enter()
            .append("g")
            .attr("class", "pie-fill");


        var circles2 = elemEnter2
            .append("circle")
            .attr("cx", function (d, i) {
                return pointX(i)
            })
            .attr("cy", function (d, i) {
                return pointYBottom(i)
            })
            // .attr("r",function(d) { return rscale(d.metric1)*20})
            .attr("r", function (d) {
                return rscale(d.metric1)
            })
            //   .style("fill","white")
            .style("fill", function (d) {
                return color(d.dim2_name)
            })
            .on("mouseover", function(d) {
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return d.dim2_name + "(" + d.dim1_name + ")" + colonAnnotation + inrFormatter(d.metric1)
                });  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on("mouseout", function() {
                // Hide the tooltip on mouse out
                tooltip.onMouseLeave();
            })
        console.log(circles2)

        var legend = rootG.append('g')
            .attr("class", "legend")
            .selectAll("g")
            .data(color.domain())
            //setting the data as we know there are only two set of data[programmar/tester] as per the nest function you have written
            .enter().append("g")
            .attr("transform", function (d, i) {
                return "translate(0," + i * 34 + ")";
            });

        const legendX = chartWidth - chartMargin.right + 40

        legend.append("rect")
            .attr('x', legendX)
            .attr('y', 70)
            .attr("width", 15)
            .attr("height", 15)
            .attr("rx", 24)
            .attr("ry", 24)
            .style("fill", color);

        legend.append("text")
            .attr("x", legendX + 28)
            .attr("y", 78)
            .attr("dy", ".35em")
            .style("font-size", axisLabelFontSize)
            .text(function (d) {
                return d
            });
    // })
}
